import { addQueryArgs } from '@wordpress/url';

const realpressImportDemo = () => {
	const importDemoNode = document.querySelector( '.realpress-import-demo-content' );
	if ( ! importDemoNode ) {
		return;
	}

	const importBtnNode = importDemoNode.querySelector( 'button' );
	const importNotifyNode = importDemoNode.querySelector( '.realpress-import-demo-notification' );
	const { __ } = wp.i18n;

	importBtnNode.addEventListener( 'click', function() {
		importBtnNode.disabled = true;
		importNotifyNode.innerHTML = __( 'System is running…', ' realpress' );
		const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
		wp.apiFetch( {
			path: addQueryArgs( '/' + restNamespace + '/import-demo' ),
			method: 'POST',
		} ).then( ( res ) => {
			if ( res.msg ) {
				importNotifyNode.innerHTML = `<p>${res.msg}</p>`;
			}
		} ).catch( ( err ) => {
			console.log( err );
		} ).finally( () => {
			importBtnNode.disabled = false;
		} );
	} );
};

export default realpressImportDemo;
